import { render, staticRenderFns } from "./AddMemberView.vue?vue&type=template&id=90651b58"
import script from "./AddMemberView.vue?vue&type=script&lang=js"
export * from "./AddMemberView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports